import "./Download.scss";
import PlayStore from "../../assets/images/png/playstore.png";
import {
  downloadAppSecure,
  downloadAppApproval,
  downloadAppPercentage,
  downloadPhone,
} from "../../assets/images/svg/DownloadApp";

const Download = ({ className }) => {
  const handleClick = () => {
    return window.open(
      "https://play.google.com/store/apps/details?id=in.loanfront.android",
      "_blank",
    );
  };
  return (
    <>
      <div className={`downloadContainer ${className}`}>
        <div className="leftCard">
          <img src={downloadPhone} alt="" />
        </div>
        <div className="rightCard" onClick={handleClick}>
          <p className="heading">
            Download our Android App <br />
            <span>For a better experience</span>
          </p>
          <div className="benefitsCard">
            <div className="benefit">
              <div className="imgCard">
                <img src={downloadAppApproval} alt="" />
              </div>
              <div className="benefitContent">
                <p className="benefitHeading">Faster Approvals</p>
                <p className="benefitSubHeading">Get quick loan approvals</p>
              </div>
            </div>
            <div className="benefit">
              <div className="imgCard">
                <img src={downloadAppPercentage} alt="" />
              </div>
              <div className="benefitContent">
                <p className="benefitHeading">Best Interest Rates</p>
                <p className="benefitSubHeading">Lower rates, more savings</p>
              </div>
            </div>
            <div className="benefit">
              <div className="imgCard">
                <img src={downloadAppSecure} alt="" />
              </div>
              <div className="benefitContent">
                <p className="benefitHeading">Secure & Trusted</p>
                <p className="benefitSubHeading">
                  Your data is 100% safe with us
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        className="playStoreLink"
        src={PlayStore}
        alt=""
        onClick={handleClick}
      />
    </>
  );
};

export default Download;
